import styled from "styled-components";
import theme from "../../theme";

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 900;
  height: ${theme.layout.header};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 32px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid ${theme.color.border};

  @media (max-width: ${theme.layout.breakpoint}) {
    padding: 0 16px;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;

  .toggle {
    display: grid;
    place-items: center;
    width: 36px;
    height: 36px;
    flex: none;
    border: 1px solid ${theme.color.border};
    border-radius: ${theme.radius.sm};
    background: ${theme.color.surface};
    color: ${theme.color.textMuted};
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover {
      background: ${theme.color.surfaceAlt};
      color: ${theme.color.text};
    }
  }

  .crumb {
    min-width: 0;

    h2 {
      font-size: ${theme.font.h3};
      font-weight: 600;
      color: ${theme.color.text};
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    span {
      font-size: ${theme.font.tiny};
      color: ${theme.color.textFaint};
    }

    @media (max-width: 520px) {
      display: none;
    }
  }
`;

export const HeaderComponents = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Searchbar = styled.div`
  position: relative;

  input {
    width: 320px;
    height: 40px;
    border-radius: ${theme.radius.pill};
    border: 1px solid ${theme.color.border};
    background: ${theme.color.surfaceAlt};
    padding: 0 16px 0 40px;
    color: ${theme.color.text};
    font-size: ${theme.font.body};

    &:focus {
      outline: none;
      border-color: ${theme.color.brand};
      background: ${theme.color.surface};
    }
  }

  img {
    position: absolute;
    top: 11px;
    left: 14px;
    width: 18px;
  }

  @media (max-width: 991px) {
    display: none;
  }
`;

export const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  .icon-button {
    position: relative;
    display: grid;
    place-items: center;
    width: 38px;
    height: 38px;
    border-radius: ${theme.radius.pill};
    border: 1px solid ${theme.color.border};
    background: ${theme.color.surface};
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: ${theme.color.surfaceAlt};
    }

    svg {
      color: ${theme.color.textMuted};
    }
  }

  .nav-item {
    position: relative;
  }

  .dropBtn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 10px 4px 4px;
    border: 1px solid ${theme.color.border};
    border-radius: ${theme.radius.pill};
    background: ${theme.color.surface};
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: ${theme.color.surfaceAlt};
    }
  }

  .circled {
    display: grid;
    place-items: center;
    background-color: ${theme.color.brandDark};
    color: #fff;
    border-radius: 50%;
    width: 32px;
    height: 32px;

    svg {
      width: 17px;
      height: 17px;
    }
  }

  .who {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
    text-align: left;

    strong {
      font-size: ${theme.font.small};
      font-weight: 600;
      color: ${theme.color.text};
      text-transform: capitalize;
    }

    small {
      font-size: 11px;
      color: ${theme.color.textFaint};
      text-transform: capitalize;
    }

    @media (max-width: 640px) {
      display: none;
    }
  }

  .caret {
    width: 11px;
    color: ${theme.color.textFaint};
  }

  .dropdown-content {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background-color: ${theme.color.surface};
    min-width: 180px;
    font-size: ${theme.font.body};
    border: 1px solid ${theme.color.border};
    box-shadow: ${theme.shadow.md};
    z-index: 20;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    border-radius: ${theme.radius.md};
    max-height: 0;
    transition: opacity 0.15s ease, max-height 0.2s ease, visibility 0.15s ease;

    a,
    button {
      width: 100%;
      font: inherit;
      background: none;
      border: 0;
      color: ${theme.color.text};
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      text-align: left;
      cursor: pointer;

      &:hover {
        background-color: ${theme.color.surfaceAlt};
      }
    }
  }

  .nav-item:hover .dropdown-content {
    visibility: visible;
    max-height: 300px;
    opacity: 1;
  }

  .notification-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background-color: ${theme.color.danger};
    color: white;
    border-radius: ${theme.radius.pill};
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0 12px;

  h3 {
    font-size: ${theme.font.h3};
    font-weight: 600;
    color: ${theme.color.text};
  }

  .close-menu {
    cursor: pointer;
    display: flex;
  }
`;

export const NavigationContainer = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  padding: 0 20px 20px;
  border-radius: ${theme.radius.lg};
  background-color: ${theme.color.surface};
  border: 1px solid ${theme.color.border};
  box-shadow: ${theme.shadow.lg};
  width: min(400px, calc(100vw - 32px));
  z-index: 30;
  overflow-y: auto;
  max-height: 460px;

  .clear {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    span {
      color: ${theme.color.textMuted};
      font-size: ${theme.font.tiny};
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .wrapper {
    padding: 12px;
    margin-bottom: 8px;
    border-radius: ${theme.radius.md};
    background: ${theme.color.surfaceAlt};

    h4 {
      color: ${theme.color.text};
      font-size: ${theme.font.small};
      font-weight: 600;
      line-height: 20px;
    }

    p {
      margin-top: 2px;
      font-size: ${theme.font.tiny};
      color: ${theme.color.textMuted};
      line-height: 18px;
    }
  }

  .empty {
    padding: 48px 0;
    text-align: center;
    font-size: ${theme.font.small};
    color: ${theme.color.textFaint};
  }
`;
